import { CLEAR_RYFT_PAYMENT_SESSION_DATA, GET_RYFT_PAYMENT_SESSION_DATA } from "../../constants/ryftPaymentSession/RyftPaymentSessionConst"


const initialState = {
    RyftPaymentSessionData: null
}
export const GetRyftPaymentSessionDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RYFT_PAYMENT_SESSION_DATA:
            console.log("payment session",action.payload)
            return {
                ...state,
                RyftPaymentSessionData: action.payload,
            }
        case CLEAR_RYFT_PAYMENT_SESSION_DATA:
            return {
               ...state,
               RyftPaymentSessionData: null,
            }
        default:
            return state
    }
}  